import SoftwareProvidersSelect from '@components/common/software-providers-select';
import { showNotification } from '@helpers/notification-helper';
import useCreateSoftwareMerchant from '@hooks/query/software-provider/useCreateSoftwareMerchant';
import { Button, Drawer, Form, TextField } from '@ui';
import React from 'react';
import { useTheme } from 'styled-components';
import { initialValues, TSubmittedValues, validationSchema } from './add-merchant-modal.schema';

interface AddMerchantModalProps {
  visible: boolean;
  onClose: () => void;
  afterSubmit?: () => void;
}

const AddMerchantModal: React.FunctionComponent<AddMerchantModalProps> = ({
  onClose,
  visible,
  afterSubmit,
}) => {
  const theme = useTheme();

  const { mutateAsync } = useCreateSoftwareMerchant({
    onSuccess: () => {
      showNotification({ type: 'SUCCESS', title: 'Externá služba pridaná', copy: '' });
      onClose();
      afterSubmit?.();
    },
    onError: () => {
      showNotification({ type: 'ERROR', title: 'Niečo sa pokazilo', copy: '' });
    },
  });

  const [form, formProps] = Form.useForm({
    initialValues,
    validationSchema,
    onSubmit: async (v) => {
      const values = v as TSubmittedValues;
      await mutateAsync({ ...values, merchantId: values.merchant.value });
    },
  });

  React.useEffect(() => {
    form?.resetForm?.();
  }, [visible]);

  return (
    <Drawer visible={visible} title={'Pridanie externej služby'} onClose={onClose}>
      <Form {...formProps}>
        <Drawer.Title>Pridajte si externú službu</Drawer.Title>
        <Drawer.Description>
          Prepojenie Hilbi s externou službou Vám umožní zdielať špecifické údaje alebo využívať
          pridané funkcionality spolu s Hilbi.
        </Drawer.Description>
        <Form.Field name="name" required label="Názov">
          <TextField />
        </Form.Field>
        <Form.Field name="merchant" required label="Služba" getValueFromEvent={Form.gve}>
          <SoftwareProvidersSelect />
        </Form.Field>
        <Form.Custom>
          {(f) => (
            <Button
              style={{ marginTop: theme.spacings.component.M }}
              loading={f.isSubmitting}
              type="submit"
            >
              Pridať
            </Button>
          )}
        </Form.Custom>
      </Form>
    </Drawer>
  );
};

export default React.memo(AddMerchantModal);
